import BeSimpleAPI from '@/providers/api/';

import { baseActions } from './../base_actions'
import { baseMutations } from './../base_mutations'

const state = 
{
    api: new BeSimpleAPI(process.env.VUE_APP_COMCEPTUM_API_URL),
    'workorders': {
        shared: false,
        items: [],
        item: {}
    },
    'workorder-statusses': [ 
        { key: 0, value: 'Nieuw' }, 
        { key: 1, value: 'Offertefase'}, 
        { key: 2, value: 'Ontwerpfase'}, 
        { key: 3, value: 'Conceptfase'}, 
        { key: 4, value: 'Productie'}, 
        { key: 5, value: 'Gereed'}, 
        { key: 6, value: 'Gefactureerd'}
    ],
    'orderlines': {
        shared: false,
        items: [],
        item: {},
        path: function(params) {
            return `/workorders/${params.workOrderId}/lines`;
        }
    },
    'ordertimes': {
        shared: false,
        items: [],
        item: {},
        path: function(params) {
            return `/workorders/${params.workOrderId}/times`;
        }
    }
}

const getters = {
    //List getters
    workOrders: state => state['workorders'].items,
    workOrderStatusses: state=> state['workorder-statusses'],
    orderLines: state=> state['orderlines'].items,
    orderTimes: state=> state['ordertimes'].items,
    //Single getters
    workOrder: state=> state['workorders'].item,
    orderLine: state => state['orderlines'].item,
    orderTime: state=> state['ordertimes'].items,
}

const actions = {
    ...baseActions,
    downloadExport({state}, command) {
        return baseActions.downloadFile(state, `export-times?startDate=${command.startDate}&endDate=${command.endDate}`, `uren-export-${command.startDate}-${command.endDate}.csv`)
    },
}

const mutations = {
    ...baseMutations
}
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}